if (process.env.REACT_APP_FORCE_MOCK || process.env.NODE_ENV === "test") {
  module.exports = require("./client.mock");
} else {
  module.exports = require("./client.prod");
}



// WEBPACK FOOTER //
// ../shared/optilit-http-client/src/index.js